import { render } from "./Companies.vue?vue&type=template&id=80980a64&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"

import "./Companies.vue?vue&type=style&index=0&id=80980a64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80980a64"]])

export default __exports__